import React from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { END } from 'redux-saga';
import Head from 'next/head';
import nextI18nextConfig from '~/../next-i18next.config';
import { wrapper } from '~/store';
import Layout from '~/containers/Layout';
import defaultPage, {
  defaultPageServerSideContext,
} from '~/../hocs/defaultPage';
import SellYourContentPage from '~/containers/SellYourContentPage';
import HrefLangs from '~/components/HrefLangs';

@defaultPage(['page-sell-your-content'])
class SellYourContent extends React.Component {
  // static getInitialProps() {
  //   return {
  //     namespacesRequired: ['common', 'page-sell-your-content'],
  //   };
  // }

  render() {
    const { t, lng } = this.props;
    console.log('test');
    return (
      <Layout>
        <Head>
          <title>{t('sell_your_content_page_title')}</title>
          <HrefLangs pagePath="/sell-your-content" lng={lng} />
        </Head>
        <SellYourContentPage />
      </Layout>
    );
  }
}

export const getServerSideProps = wrapper.getServerSideProps(
  (store) => async (ctx) => {
    const i18nProps = await serverSideTranslations(
      ctx.locale || process.env.LANGUAGE,
      ['common', 'page-sell-your-content'],
      nextI18nextConfig,
    );

    const {
      token,
      profile,
      accountType,
      isAuthenticated,
      currentLanguage,
      clientIp,
      api,
      sessionId,
      ssoToken,
      query,
    } = await defaultPageServerSideContext({
      ...ctx,
      store,
    });

    // end the saga
    store.dispatch(END);
    await store.sagaTask.toPromise();

    return {
      props: {
        ...i18nProps,
        token,
        profile,
        accountType,
        isAuthenticated,
        currentLanguage,
        sessionId,
        ssoToken,
        query,
      },
    };
  },
);

export default SellYourContent;
